import { render, staticRenderFns } from "./messageDetails.vue?vue&type=template&id=e7b48d46&scoped=true&"
import script from "./messageDetails.vue?vue&type=script&lang=ts&"
export * from "./messageDetails.vue?vue&type=script&lang=ts&"
import style0 from "./messageDetails.vue?vue&type=style&index=0&id=e7b48d46&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7b48d46",
  null
  
)

export default component.exports